import { Button, Checkbox, Col, InputNumber, Row } from 'antd';
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { observer } from 'mobx-react';
import React from "react";
import Subjects from '../../models/subjects';
import { useStore } from "../../stores/root-store";
import NumberInKimFilter from '../common/filters/number-in-kim-filter';
import SourceFilter from '../common/filters/source-filter';
import '../common/filters/style.css';
import TagsFilter from '../common/filters/tags-filter';
import TextSearchFilter from '../common/filters/text-search-filter';
import ThemeFilter from '../common/filters/theme-filter';

const FilterPanel: React.FC<{ subject: Subjects }> = ({ subject }) => {

    const { subjectStores } = useStore();
    const taskFilter = subjectStores[subject].taskFilter;
    const taskList = subjectStores[subject].taskList;

    const handleChangeWithSolution = (event: CheckboxChangeEvent): void => {
        taskFilter.changeWithSolution(event.target.checked);
    }

    const handleClickSearch = () => {
        taskList.filterTask(taskFilter.getCriteria, 1, 10);
    }

    const handleOnChangeTaskId = (value: number | null) => {
        taskFilter.changeTaskId(value);
    }

    const handleEnterClick = (e: React.KeyboardEvent<HTMLElement>): void => {
        if (e.key === 'Enter') {
            taskList.filterTask(taskFilter.getCriteria, 1, 10);
        }
    }

    const handleClearFilters = () => {
        taskFilter.clear();
    }

    return (
        <Row gutter={8} >
            <Col span={8}>
                <SourceFilter source={taskFilter.source} />
                <NumberInKimFilter numberInKim={taskFilter.numberInKim} />
                <ThemeFilter theme={taskFilter.theme} />
            </Col>
            <Col span={8}>
                <TagsFilter {...{ data: taskFilter.tags }} />
                <InputNumber placeholder="номер задачи" min={1} className="filter__item" onChange={handleOnChangeTaskId} value={taskFilter.taskId}
                    onPressEnter={handleClickSearch} />
                <Checkbox style={{ width: '100%' }} onChange={handleChangeWithSolution} checked={taskFilter.withSolution}>Есть решение</Checkbox>
            </Col>
            <Col span={8}>
                <TextSearchFilter textFilter={taskFilter.textFilter} onPressEnter={handleClickSearch} />
                <Button style={{ width: '48%', marginRight: "4%" }} onClick={handleClearFilters}>Сбросить фильтры</Button>
                <Button type="primary" style={{ width: '48%' }} onClick={handleClickSearch}>Найти</Button>
            </Col>
        </Row>
    );
};

export default observer(FilterPanel);